import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import { sinisterChildrenRoutes } from './sinisterChildrenRoutes';

const NotFoundPage = lazy(() => import('../../pages/404NotFound').then(module => ({ default: module.NotFound })));

interface RouteItem {
  path: string;
  element: JSX.Element;
}

const sinisterRoutes = {
  path: '/siniestros',
  element: <Outlet />,
  errorElement: <NotFoundPage />,
  children: [
    ...sinisterChildrenRoutes.map(({ path, element }: RouteItem) => ({
      path,
      element,
    })),
  ],
};

export default sinisterRoutes;
